<div class="container mt-3">
  <br>
  <div id="titlesDiv">
    <br>
    <h2 class="ml-3">Pregled dokumenata za provjeru</h2>
      <br>
    <h5 class="ml-3">Pregled prava za zastupanje i prava pristupa na e-uslugu koji čekaju provjeru skupnog potpisivanja Kontrolora skupnog potpisa</h5>  
      <br>
  </div>
  <br>
  <form
    class="form-control-form"
    nz-form
    [formGroup]="form"
    nzLayout="vertical"
    nz-flex
    nzAlign="end"
    nzWrap="wrap"
    (ngSubmit)="onFormSubmit()">
    <div class="form-control-input">
      <nz-form-item>
        <nz-form-control>
          <input
            placeholder="Poslovni subjekt"
            nz-input
            formControlName="BusinessSubject" />
        </nz-form-control>
      </nz-form-item>
<br>
      <nz-form-item>
        <nz-form-control>
          <input
            placeholder="Ovlaštenje"
            nz-input
            formControlName="Service" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <button
      class="mr-2 mt-3 mb-3"
      nz-button
      type="submit"
      nzType="primary">
      Pretraži
    </button>
    

    <button
      class="mt-3 mb-3"
      (click)="clearForm()"
      nz-button
      nzDanger>
      Poništi
    </button>
  </form>

  <div class="table-container">
    <app-expandable-table
      [tableColumns]="tableColumns()"
      [tableData]="tableData()"
      (tableRefresh)="RefreshData()"
      [tablePagination]="tablePagination()"
      (rowExpanded)="onRowClick($event)"
      [dynamicComponent]="DynamicComponent"
      (queryParamsTable)="onQueryParamsTable($event)">
    </app-expandable-table>
  </div>
</div>
